export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export const hexToRgba = (hex: string, alpha: number) => {
  // Remove the hash if it exists
  const cleanHex = hex.replace("#", "");
  // Convert hex to RGB
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const currencyFormatter = (
  price: number | string = 0,
  showCurrencySymbol = true,
  options = { locale: "en-IN", currency: "INR" },
) => {
  const formatter = new Intl.NumberFormat(options.locale, {
    style: "currency",
    currency: options.currency,
  });
  const formattedPrice = formatter.format(+price);

  const finalPrice = Number.isInteger(Number(price))
    ? formattedPrice.slice(0, formattedPrice.length - 3)
    : formattedPrice;

  return showCurrencySymbol ? finalPrice : finalPrice.slice(1);
};

export * from "../utils/font-loader";
